var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.componentName,{tag:"component",attrs:{"instance":_vm.module['content'],"id":_vm.module['id'],"lang":_vm.lang,"country":_vm.country,"forceBackground":_vm.forceBackground}})}
var staticRenderFns = []

export { render, staticRenderFns }